namespace $.$$ {

	export class $shm_hitalama_resizer_side extends $.$shm_hitalama_resizer_side {

		private width_start = 0

		enabled(): boolean {
			const side = this.resize_side()
			return side === 'left' || side === 'right'
		}

		width( next?: number ): number {
			return this.$.$mol_state_local.value( this.toString()+'.width', next ) ?? super.width()
		}

		width_px(): string {
			return `${ this.width() }px`
		}

		display(): string {
			return this.enabled() ? 'flex' : 'none'
		}

		left(): string {
			return this.resize_side() === 'left' ? '-6px' : 'auto'
		}

		right(): string {
			return this.resize_side() === 'right' ? '-6px' : 'auto'
		}

		on_drag_start() {
			this.width_start = this.width()
		}

		on_drag_end() {
			this.width_start = this.width()
		}

		x( next?: number ): number {
			if( next === undefined ) return 0
			if( !this.enabled() ) return next

			const sign = this.resize_side() === 'left' ? -1 : 1
			const width_next = this.width_start + next * sign
			const width_limited = Math.max( this.width_min(), Math.min( this.width_max(), width_next ) )
			this.width( width_limited )

			return next
		}

	}

}
